<div>
  <app-total-card-header></app-total-card-header>

  <form *ngIf="totalCardOrderForm" [formGroup]="totalCardOrderForm">
    <mat-horizontal-stepper [linear]="true" (selectionChange)="onStepChange($event)" #stepper>




      <mat-step formGroupName="name" [stepControl]="totalCardOrderForm.controls.name"
                [editable]="!totalCardOrderForm.disabled">
        <ng-template matStepLabel>{{"TOTALCARD.PERSONAL_DATA.LABEL" | translate}}</ng-template>
        <mat-card class="step-card">
          <mat-card-header>
            <mat-card-title>{{"TOTALCARD.PERSONAL_DATA.TITLE" | translate}}</mat-card-title>
            <mat-card-subtitle>{{"TOTALCARD.PERSONAL_DATA.SUBTITLE" | translate}}</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>


            <mat-form-field>
              <input matInput appTitleCase [placeholder]="'TOTALCARD.PERSONAL_DATA.FORM.COMPANY_NAME' | translate"
                     formControlName="companyName"
                     minlength="2" maxlength="100" required>
              <mat-error>
                {{'TOTALCARD.PERSONAL_DATA.FORM.COMPANY_NAME_LENGTH_EXCEEDED' | translate}}
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <mat-select [placeholder]="'TOTALCARD.PERSONAL_DATA.FORM.COMPANY_FORM' | translate"
                          formControlName="corporateFormId"
                          required>
                <mat-option *ngFor="let form of corporateForms" [value]="form.id">
                  {{form.name}}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field>
              <input matInput appTitleCase
                     [placeholder]="'TOTALCARD.PERSONAL_DATA.FORM.COMPANY_NAME_ON_CARDS' | translate"
                     formControlName="companyNameOnCards"
                     maxlength="23">
              <mat-error>
                {{'TOTALCARD.PERSONAL_DATA.FORM.COMPANY_NAME_LENGTH_EXCEEDED' | translate}}
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <input matInput appTitleCase [placeholder]="'TOTALCARD.PERSONAL_DATA.FORM.ADDRESS' | translate"
                     formControlName="address"
                     maxlength="50" required>
            </mat-form-field>
            <mat-form-field>
              <input matInput [placeholder]="'TOTALCARD.PERSONAL_DATA.FORM.BUILDING' | translate"
                     formControlName="building"
                     required>
            </mat-form-field>
            <mat-form-field>
              <input matInput [placeholder]="'TOTALCARD.PERSONAL_DATA.FORM.ZIP' | translate" formControlName="zipCode"
                     maxlength="50" required>
            </mat-form-field>
            <mat-form-field>
              <input matInput appTitleCase [placeholder]="'TOTALCARD.PERSONAL_DATA.FORM.CITY' | translate"
                     formControlName="city"
                     maxlength="50" required>
            </mat-form-field>
            <mat-form-field>
              <mat-select [placeholder]="'TOTALCARD.PERSONAL_DATA.FORM.COUNTRY' | translate"
                          formControlName="countryIsoCode"
                          required>
                <mat-option *ngFor="let country of countries" [value]="country.isoCode">
                  {{_currentLanguage === 'de' ? country.nameDE : country.name}}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field>
              <input matInput [placeholder]="'TOTALCARD.PERSONAL_DATA.FORM.LANDLINE' | translate"
                     formControlName="landline"
                     minlength="6" maxlength="70"
              >
            </mat-form-field>

            <mat-form-field>
              <input matInput [placeholder]="'TOTALCARD.PERSONAL_DATA.FORM.VAT_ID' | translate" formControlName="vatid"
                     minlength="6" maxlength="12"
                     pattern="">
            </mat-form-field>

            <br>
            <mat-checkbox class="thin-checkbox" formControlName="privacyPolicy" [(ngModel)]="isConfirmed"
                          [checked]="isConfirmed" required style="margin-right: 8px;"></mat-checkbox>
            <span>
              {{'TOTALCARD.PERSONAL_DATA.FORM.CHECKBOXES.BEFORE_PRIVACY' | translate}}
              <a target="_blank"
                 [routerLink]="'../documents/' + links[0]">{{docsNames.labels.license_agreement | translate}}</a>
              {{'ORDER.FULL_NAME.FORM.CHECKBOXES.AND' | translate}}
              <a target="_blank"
                 [routerLink]="'../documents/' + links[1]">{{docsNames.labels.terms_and_services | translate}}</a>
            </span>
            <br>
            <mat-checkbox class="thin-checkbox" formControlName="wantNews">
              {{'TOTALCARD.PERSONAL_DATA.FORM.CHECKBOXES.RECEIVE_UPDATES' | translate}}
            </mat-checkbox>

          </mat-card-content>
          <mat-card-actions align="end">
            <button mat-raised-button matStepperPrevious type="button">{{"BUTTON.PREVIOUS" | translate}}</button>
            <div fxFlex></div>
            <button mat-raised-button [disabled]="!isConfirmed || totalCardOrderForm.get('name').status==='INVALID'"
                    matStepperNext color="primary" type="button">{{"BUTTON.NEXT" | translate}}</button>
          </mat-card-actions>
        </mat-card>
      </mat-step>

      <mat-step formGroupName="contact" [stepControl]="totalCardOrderForm.controls.contact"
                [editable]="!totalCardOrderForm.disabled">
        <ng-template matStepLabel>{{"TOTALCARD.CONTACT.LABEL" | translate}}</ng-template>
        <mat-card class="step-card">
          <mat-card-header>
            <mat-card-title>{{"TOTALCARD.CONTACT.TITLE" | translate}}</mat-card-title>
            <mat-card-subtitle>{{"TOTALCARD.CONTACT.SUBTITLE" | translate}}</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <mat-form-field>
              <input matInput [placeholder]="'TOTALCARD.CONTACT.FORM.EMAIL' | translate" formControlName="email"
                     required minlength="7" maxlength="70"
                     pattern="^[a-z0-9](\.?[a-z0-9_-]){0,}@[a-z0-9-]+\.([a-z]{1,6}\.)?[a-z]{2,6}$">
              <mat-error>
                {{'TOTALCARD.CONTACT.FORM.EMAIL_NOT_VALID_OR_IN_USE' | translate}}
              </mat-error>
            </mat-form-field>
            <div *ngIf="isCheckingEmail">
              {{'TOTALCARD.CONTACT.FORM.CHECKING_EMAIL' | translate}}
            </div>
            <mat-form-field>
              <input matInput [placeholder]="'TOTALCARD.CONTACT.FORM.CONFIRM_EMAIL' | translate"
                     formControlName="confirmEmail" maxlength="70" required>
            </mat-form-field>

            <div style="margin-top: 10px;">{{"TOTALCARD.CONTACT.CONTACT_PERSON" | translate}}</div>

            <mat-form-field>
              <mat-select [placeholder]="'TOTALCARD.PERSONAL_DATA.FORM.TITLE' | translate" formControlName="title"
                          required>
                <mat-option *ngFor="let title of titles" [value]="title">{{title}}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field>
              <input matInput appTitleCase [placeholder]="'TOTALCARD.PERSONAL_DATA.FORM.FIRST_NAME' | translate"
                     formControlName="firstName"
                     minlength="2" maxlength="50" pattern="^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s-]*)$">
              <mat-error>
                {{'TOTALCARD.PERSONAL_DATA.FORM.FIRST_AND_LAST_NAME_LENGTH_EXCEEDED' | translate}}
              </mat-error>
            </mat-form-field>
            <mat-form-field>
              <input matInput appTitleCase [placeholder]="'TOTALCARD.PERSONAL_DATA.FORM.LAST_NAME' | translate"
                     formControlName="lastName"
                     minlength="2" maxlength="50" pattern="^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s-]*)$">
              <mat-error>
                {{'TOTALCARD.PERSONAL_DATA.FORM.FIRST_AND_LAST_NAME_LENGTH_EXCEEDED' | translate}}
              </mat-error>
            </mat-form-field>

            <app-date-edit [placeholder]="'TOTALCARD.PERSONAL_DATA.FORM.DOB' | translate" formControlName="dob" required
                           [max]="maxDob" [min]="minDob"></app-date-edit>
            <mat-error *ngIf="totalCardOrderForm.get('contact').get('dob').hasError('required')">
              {{'TOTALCARD.PERSONAL_DATA.FORM.DOB_IVALID' | translate}}
            </mat-error>

            <app-total-phone-input
              formControlName="phone" (nextStep)="nextStep(stepper)" minlength="9" maxlength="15" required
            >
            </app-total-phone-input>


          </mat-card-content>
          <mat-card-actions align="end">
            <button mat-raised-button matStepperPrevious type="button">{{"BUTTON.PREVIOUS" | translate}}</button>
            <div fxFlex></div>

          </mat-card-actions>
        </mat-card>

      </mat-step>

      <mat-step formGroupName="cards" [stepControl]="totalCardOrderForm.controls.cards"
                [editable]="!totalCardOrderForm.disabled">

        <ng-template matStepLabel>{{"TOTALCARD.CARDS.LABEL" | translate}}*</ng-template>
        <mat-card class="step-card" style="max-width: 100%">
          <mat-card-header>
            <mat-card-title>{{"TOTALCARD.CARDS.TITLE" | translate}}</mat-card-title>
            <mat-card-subtitle>{{"TOTALCARD.CARDS.SUBTITLE" | translate}}</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>


            <div *ngIf="cardDefinitions != null">


              <div style="max-width: 150px;">
                <mat-form-field>
                  <input matInput appTitleCase [placeholder]="'TOTALCARD.CARDS.COMPANY_PIN' | translate"
                         formControlName="companyPin"
                         maxlength="4">
                </mat-form-field>
              </div>


              <div formGroupName="cards" *ngFor="let card of getCardControls().controls; let i=index">
                <div [formGroupName]="i">
                  <div fxLayout="row wrap" fxLayoutAlign="flex-start center" fxLayoutGap="15px">

                    <mat-form-field fxFlex="12">
                      <input matInput appTitleCase [placeholder]="'TOTALCARD.PERSONAL_DATA.CARDS.DRIVER' | translate"
                             formControlName="licensePlateDriverName"
                             minlength="3" maxlength="13" required>
                    </mat-form-field>
                    <mat-form-field fxFlex="8">
                      <mat-select [placeholder]="'TOTALCARD.PERSONAL_DATA.CARDS.ACCEPTANCE' | translate"
                                  formControlName="totalCardCardAcceptanceId"
                                  required>
                        <mat-option *ngFor="let a of cardDefinitions.acceptances" [value]="a.id">
                          {{ _currentLanguage == "de" ? a.nameDe : a.nameEn }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field fxFlex="8">
                      <mat-select [placeholder]="'TOTALCARD.PERSONAL_DATA.CARDS.PRODUCT' | translate"
                                  formControlName="totalCardCardProductId"
                                  required>
                        <mat-option *ngFor="let a of cardDefinitions.products" [value]="a.id">
                          {{ _currentLanguage == "de" ? a.nameDe : a.nameEn }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field fxFlex="8">
                      <mat-select [placeholder]="'TOTALCARD.PERSONAL_DATA.CARDS.SERVICE' | translate"
                                  formControlName="totalCardCardServiceId"
                                  required>
                        <mat-option *ngFor="let a of cardDefinitions.services" [value]="a.id">
                          {{ _currentLanguage == "de" ? a.nameDe : a.nameEn }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field fxFlex="8">
                      <mat-select [placeholder]="'TOTALCARD.PERSONAL_DATA.CARDS.INFO' | translate"
                                  formControlName="totalCardCardInfoId"
                                  required>
                        <mat-option *ngFor="let a of cardDefinitions.infos" [value]="a.id">
                          {{ _currentLanguage == "de" ? a.nameDe : a.nameEn }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field fxFlex="5">
                      <mat-select [placeholder]="'TOTALCARD.PERSONAL_DATA.CARDS.PIN_TYPE' | translate"
                                  formControlName="totalCardCardPinTypeId"
                                  required>
                        <mat-option *ngFor="let a of cardDefinitions.pinTypes" [value]="a.id">
                          {{ _currentLanguage == "de" ? a.nameDe : a.nameEn }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field fxFlex="4">
                      <input matInput appTitleCase [placeholder]="'TOTALCARD.PERSONAL_DATA.CARDS.PIN' | translate"
                             formControlName="pin"
                             maxlength="4">

                    </mat-form-field>
                    <mat-form-field fxFlex="10">
                      <input matInput appTitleCase [placeholder]="'TOTALCARD.PERSONAL_DATA.CARDS.OFFICE' | translate"
                             formControlName="office"
                             maxlength="100">

                    </mat-form-field>
                    <mat-form-field fxFlex="10">
                      <input matInput appTitleCase [placeholder]="'TOTALCARD.PERSONAL_DATA.CARDS.CARD_NR' | translate"
                             formControlName="cardNumber"
                             maxlength="4">

                    </mat-form-field>
                    <mat-form-field fxFlex="9">
                      <input matInput appTitleCase [placeholder]="'TOTALCARD.PERSONAL_DATA.CARDS.NOTICE' | translate"
                             formControlName="notice"
                             maxlength="10">

                    </mat-form-field>
                    <mat-form-field fxFlex="6">
                      <mat-select [placeholder]="'TOTALCARD.PERSONAL_DATA.CARDS.VEHICLE_TYPE' | translate"
                                  formControlName="totalCardCardVehicleTypeId">
                        <mat-option *ngFor="let a of cardDefinitions.vehicleTypes" [value]="a.id">
                          {{ _currentLanguage == "de" ? a.nameDe : a.nameEn }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <!--  -->
                    <button *ngIf="i > 0" fxFlex="3" mat-icon-button color="warn" (click)="removeCard(i)">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </div>


                </div>
              </div>
              <br />
              <button mat-raised-button color="primary" style="margin-bottom: 10px;" *ngIf="getCardControls().controls.length < 20"
                      (click)="addNewCard()">{{"TOTALCARD.PERSONAL_DATA.CARDS.ADD" | translate}}</button>
              <br />
              <br />
              {{"TOTALCARD.CARDS.INSURANCE_INFO" | translate}}<br />
              <mat-checkbox class="thin-checkbox" formControlName="wantInsurance">
                {{'TOTALCARD.CARDS.INSURANCE' | translate}}
              </mat-checkbox>
              <br />
            </div>


          </mat-card-content>
          <mat-card-actions align="end">
            <button mat-raised-button matStepperPrevious type="button">{{"BUTTON.PREVIOUS" | translate}}</button>
            <div fxFlex></div>
            <button mat-raised-button [disabled]="totalCardOrderForm.get('cards').status==='INVALID'"
                    matStepperNext color="primary" type="button">{{"BUTTON.NEXT" | translate}}</button>
          </mat-card-actions>
        </mat-card>
      </mat-step>

      <mat-step formGroupName="requirements" [stepControl]="totalCardOrderForm.controls.requirements"
                [editable]="!totalCardOrderForm.disabled">
        <ng-template matStepLabel>{{"TOTALCARD.REQUIREMENTS.LABEL" | translate}}</ng-template>
        <mat-card class="step-card">
          <mat-card-header>
            <mat-card-title>{{"TOTALCARD.REQUIREMENTS.TITLE" | translate}}</mat-card-title>
            <mat-card-subtitle>{{"TOTALCARD.REQUIREMENTS.SUBTITLE" | translate}}</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <br/>
            <div>{{"TOTALCARD.REQUIREMENTS.I_NEED" | translate}}</div>
            <br/>

            <mat-select [placeholder]="'TOTALCARD.REQUIREMENTS.FORM.WHICH_CARDS' | translate"
                        formControlName="cardTypes"
                        required>
              <mat-option [value]="1">{{"TOTALCARD.REQUIREMENTS.NATIONAL_CARD" | translate}}</mat-option>
              <mat-option [value]="2">{{"TOTALCARD.REQUIREMENTS.INTERNATIONAL_CARD" | translate}}</mat-option>
              <mat-option [value]="3">{{"TOTALCARD.REQUIREMENTS.BOTH" | translate}}</mat-option>
            </mat-select>

            <br/>

            <mat-form-field>
              <input matInput [placeholder]="'TOTALCARD.REQUIREMENTS.FORM.FUEL_IN_LITERS' | translate"
                     formControlName="fuel"
                     required>
            </mat-form-field>
            <mat-form-field>
              <input matInput [placeholder]="'TOTALCARD.REQUIREMENTS.FORM.CARWASH_IN_EURO' | translate"
                     formControlName="carwash"
                     required>
            </mat-form-field>
            <mat-form-field>
              <input matInput [placeholder]="'TOTALCARD.REQUIREMENTS.FORM.TOLL_IN_EURO' | translate"
                     formControlName="toll"
                     required>
            </mat-form-field>


          </mat-card-content>
          <mat-card-actions align="end">
            <button mat-raised-button matStepperPrevious type="button">{{"BUTTON.PREVIOUS" | translate}}</button>
            <div fxFlex></div>
            <button mat-raised-button color="primary" (click)="createOrder()"
                    [disabled]="totalCardOrderForm.invalid || totalFormDisabled || totalCardOrderForm.disabled">{{"BUTTON.SUBMIT" | translate}}</button>
            <!--<button mat-raised-button matStepperNext color="primary"
                    type="button">{{"BUTTON.NEXT" | translate}}</button>-->
          </mat-card-actions>
        </mat-card>

      </mat-step>

      <!--
      <mat-step formGroupName="payment" [stepControl]="totalCardOrderForm.controls.payment"
                [editable]="!totalCardOrderForm.disabled">
        <ng-template matStepLabel>{{"TOTALCARD.PAYMENT.LABEL" | translate}}</ng-template>
        <mat-card class="step-card">
          <mat-card-header>
            <mat-card-title>{{"TOTALCARD.PAYMENT.TITLE" | translate}}</mat-card-title>
            <mat-card-subtitle>{{"TOTALCARD.PAYMENT.SUBTITLE" | translate}}</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>

            <mat-form-field>
              <input matInput [placeholder]="'TOTALCARD.PAYMENT.FORM.IBAN' | translate" formControlName="iban"
                     required>
            </mat-form-field>
            <mat-form-field>
              <input matInput [placeholder]="'TOTALCARD.PAYMENT.FORM.BIC' | translate" formControlName="bic"
                     required>
            </mat-form-field>

          </mat-card-content>
          <mat-card-actions align="end">
            <button mat-raised-button matStepperPrevious type="button">{{"BUTTON.PREVIOUS" | translate}}</button>
            <div fxFlex></div>
            <button mat-raised-button color="primary" (click)="createOrder()"
                    [disabled]="totalCardOrderForm.invalid || totalCardOrderForm.disabled">{{"BUTTON.SUBMIT" | translate}}</button>
          </mat-card-actions>
        </mat-card>

      </mat-step>
      -->

      <!-- <mat-step formGroupName="paymentType" [stepControl]="totalCardOrderForm.controls.paymentType"
                [editable]="!totalCardOrderForm.disabled">
        <ng-template matStepLabel>{{"ORDER.PAYMENT.LABEL" | translate}}</ng-template>
        <mat-card class="step-card">
          <mat-card-header>
            <mat-card-title>{{"ORDER.PAYMENT.TITLE" | translate}}</mat-card-title>
            <mat-card-subtitle>{{"ORDER.PAYMENT.SUBTITLE" | translate}}</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <app-payment-type-selector [productId]="totalCardOrderForm.value.product.productId"
                                       [allowedPaymentMethods]="allowedPaymentMethods" formControlName="paymentType" required>
            </app-payment-type-selector>
          </mat-card-content>
          <mat-card-actions align="end">
            <button mat-raised-button matStepperPrevious type="button">{{"BUTTON.PREVIOUS" | translate}}</button>
            <div fxFlex></div>
            <button mat-raised-button color="primary" (click)="createOrder()"
                    [disabled]="totalCardOrderForm.invalid || totalCardOrderForm.disabled">{{"BUTTON.SUBMIT" | translate}}</button>
          </mat-card-actions>
        </mat-card>
      </mat-step>-->
      <mat-step>
        <ng-template matStepLabel>{{"TOTALCARD.SUMMARY.LABEL" | translate}}</ng-template>
        <mat-card class="step-card">
          <mat-card-header>
            <mat-card-title>
              <div
                [innerHTML]="'TOTALCARD.SUMMARY.SUCCESS.TITLE' | translate :{'firstname': summaryPageUserAddressing?.firstName}"></div>

            </mat-card-title>
          </mat-card-header>
          <mat-card-content class="margin-left-16px">
            <div>
              <div
                [innerHTML]="'TOTALCARD.SUMMARY.SUCCESS.TEXT' | translate :{'firstname': summaryPageUserAddressing?.firstName}"></div>
            </div>

          </mat-card-content>
          <mat-card-actions align="end">


          </mat-card-actions>
        </mat-card>
      </mat-step>
    </mat-horizontal-stepper>
  </form>
</div>
